<template>
  <div class="selectIdentity bg_f5 pr">
    <div class="content bg_fff">
      <div class="title f_20 color_40 text_center font_w_b">Hi~ 欢迎来到超级简历</div>
      <div class="text f_14 color_9c text_center">选择你对应的身份吧</div>
      <div class="select text_center">
        <div class="clearfix">
          <div class="item fl cursor_p" @click="pageJump('cv_account')">
            <img src="https://files.wondercv.com/auth-frontend/select_identity_icon1.png" alt="">
            <div class="button bg_current color_fff f_14">我要找工作<span class="iconfont icon-you"></span></div>
          </div>
          <div class="item fl cursor_p" @click="pageJump('hr_account')">
            <img src="https://files.wondercv.com/auth-frontend/select_identity_icon2.png" alt="">
            <div class="button bg_blue2 color_fff f_14">我要招人<span class="iconfont icon-you"></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 所有接口
import { uuid } from 'vue-uuid';

import actions from '@/actions/index'
import * as utils from '@/utils/utils'


export default {
  data(){
    return {
      // account_type:'', //账户种类 hr_account 或 cv_account

    }
  },
  async created(){
    //如果用户已登录，返回上一页/cvs
    let _t = utils.getCookie('_t');
    if(!_t){
       window.location.href = window.location.origin+'/auth-signin'
    }
  },

  methods: {
    //【登录成功】读取跳转页面
    pageJump(account_type){
      let r_b_t = utils.getCookie('_r_b_t') || '';
      // 返回的url中必须有 wondercv
      if(!r_b_t.includes('wondercv')){
        r_b_t = '';
      }
      // 返回的url要进行解码再跳转
      if(r_b_t){
        r_b_t = decodeURIComponent(r_b_t);
      }
      let _t = utils.get_tUser();
      if(account_type==='hr_account'){
        if(!r_b_t.includes('/talent/')){
          r_b_t = '';
        }
        //如果返回的url中包含 用户信息的url
        let link_to = r_b_t.includes(`${window.location.origin}/talent/userinfo`)? ( r_b_t.includes('?')?r_b_t+'&showJump=true':r_b_t+'?showJump=true' ) : `${window.location.origin}/talent/userinfo${r_b_t ? '?link_to='+encodeURIComponent(r_b_t)+'&showJump=true' : '?showJump=true'}`;

        // hr登录之后的判断
        window.location.href = link_to ;
        utils.delCookie('_r_b_t');
      }else{
        // cv登录之后的判断
        //新用户跳转到cvs，然后自动会跳转到 选择身份页面
        window.location.href = window.location.origin+'/cvs'
        // 不是新用户 && 有 r_b_t
        // if(r_b_t && !new_account){
        //   window.location.href = r_b_t;
        //   utils.delCookie('_r_b_t');
        // }else{
        //   新用户跳转到cvs，然后自动会跳转到 选择身份页面
        //   window.location.href = window.location.origin+'/cvs'
        // }

      }
    },

  }
}
</script>

<style lang="scss" scoped>
  @import './Index.scss'
</style>